export class Client {
    constructor(id, name, email) {
        this.id = id;
        this.name = name;
        this.email = email;
    }
}
